import { Pipe, PipeTransform } from '@angular/core';
import { DeviceService } from '../../common/_services/device.service';
@Pipe({
  name: 'datadevice',
  pure: true,
  standalone: false,
})
export class DatadevicePipe implements PipeTransform {
  constructor(private deviceService: DeviceService) {}

  transform(value: any): any {
    if (!value || value === undefined) {
      return null;
    }

    const selected = this.deviceService.getDeviceById(+value);
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
